import React, { createContext, useContext, useState } from "react";
import TabPopup  from "./TabPopup";

const PopupContext = createContext();

export function PopupProvider({ children }) {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  const openPopup = (msg) => {
    setMessage(msg);
    setShow(true);
  };

  const closePopup = () => {
    setShow(false);
    setMessage("");
  };

  return (
    <PopupContext.Provider value={{ openPopup }}>
      {children}
      <TabPopup  show={show} message={message} onClose={closePopup} />
    </PopupContext.Provider>
  );
}

export function usePopup() {
  return useContext(PopupContext);
}